export const getUsers = (state) => state.users;

export const filteredUsersByOrg = (state) => (orgId) => state.users
  .reduce((filtered, user) => {
    if (user.lastName && user.organization === orgId) filtered.push(user);
    return filtered;
  }, []);
